module.exports = __webpack_public_path__ + "img/prize1.31d79d10.png";